import { NativeService } from './../../../services/native.service';
import { SelectListComponent } from './select-list.component';
import { FieldModel } from 'app/models/shared/field.model';
import { GeneralService } from 'app/services/general.service';
import { VehicleClass } from 'app/utility/enums';
import { SelectListModalComponent } from './select-list-modal.component';
import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';

import { ListItemModel } from 'app/models/shared/listItem.model';
import { Constants } from 'app/utility/constants';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-select-list-multi',
    templateUrl: './select-list-multi.component.html',
    styleUrls: ['./select-list-multi.component.scss'],
    standalone: false
})
export class SelectListMultiComponent extends SelectListComponent implements OnInit {

	/* lazyload list usage */
	@Input() id: string = '';
	@Input() sideload: any;  //this should be a list of lookups (by default, an empty guid item should exist)
	@Input() field: FieldModel;

	/* vehicle specific select*/
	@Input() detailClass: VehicleClass;


	@Input() selectedItemIds: string[]; //the ids of the selected values

	@Output() selectedItemIdsChange: EventEmitter<string[]> = new EventEmitter<string[]>();
	@Output() loaded: EventEmitter<string> = new EventEmitter<string>();

	selectedItems: ListItemModel[];

	constructor
		(
			public modalController: ModalController,
			public generalService: GeneralService,
			protected nativeService: NativeService,
			protected cd: ChangeDetectorRef
		) {
		super(modalController, nativeService, cd, generalService);
		this.displayType = 'compact';
	}

	ngOnInit() {
		if (this.sideload && this.sideload.length) // || (!this.items || this.items.length == 0))
		{
			this.loadLookupItems();
		}
		else {
			throw new Error("No valid sideload object supplied for multi-select list: " + this.label);
		}
	}

	protected configureSelectedItem() {
		//set the selected items
		this.selectedItems = [];
		this.setDisplayValue(false);

		// console.log(this.items, this.label);
		if (this.selectedItemId && this.items) {
			// console.log(this.label, "item: "+this.selectedItemId, this.items);
			for (let itemIndex in this.items) {
				let item = this.items[itemIndex];
				if (item.id == this.selectedItemId) {
					this.selectedItem = item;
					break;
				}
			}
		}

	}


	private loadLookupItems() {
		var item: ListItemModel;
		this.items = [];
		var firstSideload = this.sideload[0];

		// console.log(this.lookupCollection, item.id, x);
		this.items = this.sideload;
		this.configureSelectedItem();
		this.loading = false;
	}

	show(): void {
		if (this.field.editable == false) {
			// console.log("This field is not editable so cannot show", this.field);
			return;
		}
		this.showModal();
	}

	async showModal() {
		var statusBarColor = this.nativeService.currentColor;
		this.nativeService.setupStatusBar("light");
		var originalSelectedIds = Object.assign([], this.selectedItemIds);
		const modal = await this.modalController.create({
			component: SelectListModalComponent,
			componentProps: {
				'id': this.id,
				'title': this.label,
				'items': this.items,
				'selectAllLabel': this.selectAllLabel,
				'selectedValue': this.selectedValue,
				'selectedItemIds': this.selectedItemIds,
				'displayType': this.displayType,
				'multiSelect': true,
			}
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		this.nativeService.setupStatusBar(statusBarColor);
		if (data && data.changed) {
			this.setSelectedItems();
		}
	}

	setSelectedItem(item: ListItemModel, emit: boolean): void {
		//overridden as we don't want to use this function
	}

	setSelectedItems(): void {
		this.setDisplayValue();
		this.selectedItemIdsChange.emit(this.selectedItemIds);
	}

	clearSelectedItem(): void {
		this.selectedItem = null;
		this.selectedItemId = Constants.EmptyGuid;
	}

	public setDisplayValue(emit: boolean = true) {
		this.selectedItems = this.items.filter(
			(x: ListItemModel) => (this.selectedItemIds.indexOf(x.id) >= 0)
		);
		var captions: string[] = [];
		this.selectedItems.forEach(function (item) {
			captions.push(item.name);
		});
		this.selectedValue = captions.join(", ");

        if (this.selectedItems.length == this.items.length) {
            this.selectedValue = "All " + this.field.label;
        }

		if (emit) {
			// console.log("setDisplayValue loaded.emit");
			this.loaded.emit(this.selectedValue);
		}
	}

	getDisplayValue(): string {
		return (this.selectedValue && this.selectedValue.trim() != '') ? this.selectedValue : '-';
	}

	itemHasValue() {
		return (this.selectedValue && this.selectedValue.trim() != '');
	}
	scrollTop: boolean = true;
	ionScrollEvent(ev:any){
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop!=scrollTop) {
			this.scrollTop = scrollTop;
		}
	}
}
